import React, { useState, useEffect, useMemo, useRef } from 'react';
import FlexView from 'react-flexview/lib';
import { GridResultsScreen } from './Grid/GridResultsScreen';
import {EuiFlexGroup,EuiSpacer} from '@elastic/eui';
import { ESTADOS, USER_PERMISSIONS } from './constants';
import FiltrosMenu from '../../../components/Menus/filtros';
import { Action } from '../../../components/Menus/interface';
import { Menu } from '../../../components/Menus';
import { useUserSettings } from '../../../context/CurrentUserContext';

interface Props {
  data: any;
  handleFilter(filtro: any): any;
}

const ControlFuncionesSubFuncionesScreen = (props: Props) => {
  const ref:any = useRef();
  let { data, handleFilter} = props;
  let {currentUser}:any = useUserSettings();

  const permisosUser = useMemo(()=>{
    switch (currentUser.perfil) {
      case 'RAR':
        return USER_PERMISSIONS.RAR
      case 'FIS':
        return USER_PERMISSIONS.FIS
      case 'FAC':
        return USER_PERMISSIONS.FAC
      case 'ADM':
        return USER_PERMISSIONS.ADM
    }
  },[currentUser])

  
  let [selected, setSelected] = useState<any>([]);
  let [filtro, setFiltro] = useState<any>(undefined)
  let [codEstadoFiltered, setEstadoFiltered] = useState(ESTADOS.RESPONSABLE_AREA.codEstado);

  useEffect(() => {setSelected([]) }, [data]);

  useEffect(()=> {
    if(filtro){
      setEstadoFiltered(filtro.estado);
      filtrarPartes();
    }
  },[filtro])
  
  const onExport = () =>{
    ref && ref.current.onExport();
  }

  const onFilterClear = () => { 
    ref.current && ref.current.onFilterClear()
  }

  const onSelected = (selection: any) => {
    setSelected(selection[0])
  }

  const filtroInicial = (filtro:any)=>{
    setFiltro(filtro);
    handleFilter && handleFilter(filtro)
  }

  const filtrarPartes = () => {
    handleFilter(filtro)
  }

  const Actions = useMemo(():Action[] => [
    {handle:onFilterClear,text:"Limpiar Filtro",size:"s", isDisabled: false, className: "btnFilterClear"},
    {handle:onExport,text:"Exportar",size:"s", isDisabled:false}
  ],[])

  const getView = () => {
    return (
      <>
        <GridResultsScreen
          data={data}
          selector={false}
          onSelected={onSelected}
          onChange={()=>{}}
          ref={ref}
        />
      </>
    )
  }

  return (
    <FlexView column basis="100%">
        <EuiFlexGroup gutterSize="s" alignItems="center" className="wrapperMenuPage">
          <EuiFlexGroup alignItems={'center'} justifyContent="flexStart" className="filter">
            <FiltrosMenu filtroInicial = {filtroInicial} onChangeFilter={setFiltro}/>
          </EuiFlexGroup>
          <Menu actions={Actions} className="actions"/>
         </EuiFlexGroup>
        <EuiSpacer size="m" />
      <FlexView grow={1} shrink={1} basis="auto">
        <FlexView column shrink={0} basis="100%">
          {getView()}
        </FlexView>
      </FlexView>
    </FlexView>
  );
};

export default ControlFuncionesSubFuncionesScreen;
